import { Controller } from 'stimulus';

export default class AutoselectInputController extends Controller {
  static targets = ['input'];

  inputTarget: HTMLInputElement;

  connect() {
    this.select();
  }

  select(evt?: any) {
    if (evt) evt.preventDefault();
    this.inputTarget.select();
  }
}
